import { useCallback, useMemo } from 'react';

export default ({ tabKeys, activeTabKey, setActiveTabKey }) => {
  const tabCount = tabKeys.length;

  const activeIndex = useMemo(() => {
    const foundIndex = tabKeys.indexOf(activeTabKey);
    return Math.max(foundIndex, 0);
  }, [tabKeys, activeTabKey]);

  const moveLeft = useCallback(() => {
    const nextIndex = (activeIndex - 1 + tabCount) % tabCount;
    setActiveTabKey(tabKeys[nextIndex]);
  }, [activeIndex, tabCount, tabKeys, setActiveTabKey]);

  const moveRight = useCallback(() => {
    const nextIndex = (activeIndex + 1) % tabCount;
    setActiveTabKey(tabKeys[nextIndex]);
  }, [activeIndex, tabCount, tabKeys, setActiveTabKey]);

  return { moveLeft, moveRight };
};
